import { render } from "./CategoryStats.vue?vue&type=template&id=e815b15a"
import script from "./CategoryStats.vue?vue&type=script&lang=js"
export * from "./CategoryStats.vue?vue&type=script&lang=js"

import "./CategoryStats.vue?vue&type=style&index=0&id=e815b15a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/tests/CategoryStats.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e815b15a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e815b15a', __exports__)) {
    api.reload('e815b15a', __exports__)
  }
  
  module.hot.accept("./CategoryStats.vue?vue&type=template&id=e815b15a", () => {
    api.rerender('e815b15a', render)
  })

}


export default __exports__